import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Navigate, Route, Routes } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import LinearProgress from '@mui/material/LinearProgress';
import Navbar from './Components/Navbar';
import History from './Views/History/History';
import Dashboard from './Views/Dashboard/Dashboard';
import Kanban from './Views/Orders/Kanban';
import LogIn from './Views/LogIn/LogIn';
import { queryClient } from './hooks/useQuery';
import { useAppState } from './hooks/useAppState';
import ContextManager from './Components/ContextManager';

function AuthenticatedApp() {
    return (
        <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools />
            <ContextManager>
                <Routes>
                    <Route path="/" element={<Navbar />}>
                        <Route path="/" element={<Navigate to="/orders" replace />} />
                        <Route path="orders" element={<Kanban />} />
                        <Route path="orders/:id" element={<Kanban />} />
                        <Route path="dashboard" element={<Dashboard />}>
                            <Route path="mercadopago-setup" element={<Dashboard />} />
                        </Route>
                        <Route path="historial" element={<History />} />
                        <Route path="login" element={<Navigate to="/" replace />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Route>
                </Routes>
            </ContextManager>
        </QueryClientProvider>
    );
}

function UnauthenticatedApp() {
    return (
        <Routes>
            <Route path="/login" element={<LogIn />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
    );
}

export default function App() {
    const { appInitialized, isSignedIn } = useAppState();

    if (!appInitialized) {
        return <LinearProgress />;
    }
    if (!isSignedIn) {
        return <UnauthenticatedApp />;
    }
    return <AuthenticatedApp />;
}
